import {
    RetentionFeatureSlice,
    InviteLinksFeatureSlice,
    InviteLinksGroupSlice,
    AudienceSlice,
    RetentionGroupsSlice,
    MarkingModalSlice,
} from './slices'

export interface InviteLinksState
    extends RetentionFeatureSlice,
        InviteLinksFeatureSlice,
        InviteLinksGroupSlice,
        RetentionGroupsSlice,
        AudienceSlice,
        MarkingModalSlice {}

export const initialState = {
    chartsIsExpanded: false,
    inviteLinksByChannel: {},
    tableFormatInviteLinksByChannel: {},
    startEndDateByChannel: {},
    selectedLinksRetentionByChannel: {},
    selectedLinksInviteByGroup: {},
    audienceByChannel: {},
    selectedRetentionGroups: {},
    startDateRetentionGroup: '',
    endDateRetentionGroup: '',
}
